import {Layout, Divider, Typography, Image} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Paragraph, Text} = Typography;
const {Content} = Layout;

const CollaborationPart1 = () => {
  return (
    <Layout style={{margin: '80px 50px 50px 50px', background: 'inherit'}}>
      <Paragraph className='Title2' style={{color: appColors['ColorNa']}}>Collaborations</Paragraph>
      <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '-8vh'}}>Collaboration with iGEM UFMG/UFV Brazil</Paragraph>
      <Text className='BaseText' style={{textAlign: 'justify', textJustify: 'inter-word'}}><Text className='BaseText'>We focused on public engagement and <b>attracting people to our project</b> and to synthetic biology because as a team we faithfully believe that science is for everyone, regardless of gender, age or nationality. One way to reach more population is through social media as millions of people use it at least once a day. To make our Instagram feed more accessible and universal, we decided to make our content both in Spanish, our language, and English. We addressed several topics such as: Disruptive Science, Aging, Intersectional space among others.</Text></Text>
      <Content style={{display: 'block', maxWidth: '80%', marginLeft: 'auto', marginRight: 'auto', marginTop: '30px', background: 'inherit'}}>
        <Image.PreviewGroup>
          <Image width={'50%'} src='https://static.igem.wiki/teams/4464/wiki/team/collaborations/1-meetup-latam.png'></Image>
          <Image width={'50%'} src='https://static.igem.wiki/teams/4464/wiki/team/collaborations/2-meetup-latam.png'></Image>
        </Image.PreviewGroup>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default CollaborationPart1;
